__turbopack_context__.v({
  "imageGrid": "tulli-module__7f2sKa__imageGrid",
  "page": "tulli-module__7f2sKa__page",
  "storySection": "tulli-module__7f2sKa__storySection",
});
